<form *ngIf="form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="resetPsw()" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row" style="justify-content: center; margin-bottom: 10px;">
      <label>{{ 'customers.new_password' | translate }}</label>
    </div>
    <div class="ui-grid-row">
      <input formControlName="password" type="text" pInputText />
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 10px;">
      <br />
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ ('customers.auth_reset' | translate) }} "></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-psw-reset-form/user-psw-reset-form.component.html